import { render, staticRenderFns } from "./proceedInfo.vue?vue&type=template&id=06ea802f&"
import script from "./proceedInfo.vue?vue&type=script&lang=js&"
export * from "./proceedInfo.vue?vue&type=script&lang=js&"
import style0 from "./proceedInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports